function initLimitedVariants(root = document) {
  const fieldsets = root.querySelectorAll('.variant-limit-fieldset');

  fieldsets.forEach((fieldset) => {
    if (fieldset.dataset.variantLimitInitialized === 'true') return;
    fieldset.dataset.variantLimitInitialized = 'true';

    const limit = parseInt(fieldset.dataset.initialLimit || '4', 10);
    const toggleButton = fieldset.querySelector('[data-show-more-variants]');
    if (!toggleButton) return;

    // NEU: Speichere den ursprünglichen Text (+ 17 weitere...) beim ersten Laden
    const originalText = toggleButton.textContent;

    const wrapper = fieldset.querySelector('.variant-limit-wrapper');
    if (!wrapper) return;

    const items = getVariantItems(wrapper, fieldset);

    if (items.length <= limit) {
      toggleButton.style.display = 'none';
      return;
    }

    items.forEach((item, index) => {
      item.classList.add('variant-limit-item');
      if (index >= limit) {
        item.classList.add('is-hidden-by-limit');
      }
    });

    fieldset.classList.add('is-collapsed');

    toggleButton.addEventListener('click', () => {
      const isCollapsed = fieldset.classList.contains('is-collapsed');

      if (isCollapsed) {
        fieldset.classList.remove('is-collapsed');
        toggleButton.textContent = 'Weniger anzeigen'; // Text beim Ausklappen
        toggleButton.setAttribute('aria-expanded', 'true');
      } else {
        fieldset.classList.add('is-collapsed');
        // GEÄNDERT: Nutze hier den gespeicherten Original-Text statt "Mehr anzeigen"
        toggleButton.textContent = originalText; 
        toggleButton.setAttribute('aria-expanded', 'false');
      }
    });
  });
}

function getVariantItems(wrapper, fieldset) {
  let items = [];

  const swatchGrid = wrapper.querySelector('.product-form-swatch__variants');
  if (swatchGrid) {
    items = Array.from(swatchGrid.children).filter(Boolean);
  }

  if (!items.length) {
    const radioInputs = Array.from(wrapper.querySelectorAll('input[type="radio"]'));

    items = radioInputs
      .map((input) => {
        const labelByFor = fieldset.querySelector(`label[for="${input.id}"]`);
        if (labelByFor) return labelByFor;

        const closestLabel = input.closest('label');
        if (closestLabel) return closestLabel;

        return input.parentElement;
      })
      .filter(Boolean);
  }

  return [...new Set(items)];
}

/* Sofort ausführen */
initLimitedVariants();

/* Für dynamisch nachgeladene Shopify-Sections */
document.addEventListener('shopify:section:load', (event) => {
  initLimitedVariants(event.target);
});